export default {
      id: "3iLogo-usage",
      viewBox: "0 0 70 32",
      url: "assets/" + "sprite.svg#3iLogo-usage",
      toString: function () {
        return this.url;
      }
    }